import React from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getCalloutExtensionStyles } from '../styles';

const CalloutExtension = ({
  classes,
  extensionData,
}) => (
  <div className={classes.calloutExtensionContainer}>
    <span>{extensionData.map(({ Text }) => Text).join(' · ')}</span>
  </div>
);

CalloutExtension.propTypes = {
  classes: PropTypes.shape({
    calloutExtensionContainer: PropTypes.string,
  }),
  extensionData: PropTypes.arrayOf(PropTypes.shape({
    Text: PropTypes.string,
  })),
};

CalloutExtension.defaultProps = {
  classes: {},
  extensionData: [],
};

export const AdPreviewCalloutExtension = withUAPLThemedStyles(
  CalloutExtension,
  getCalloutExtensionStyles, { componentName: 'AdPreviewCalloutExtension' }
);
